<template>
  <div v-if="orderRejectReason" class="order-reject-reason">
    <div class="order-reject-reason-title">{{title}}</div>
    <div v-for="(item,index) in orderRejectReason.split('###')" :key="index" class="order-reject-reason-list">
      <div class="seq">{{index+1}}.</div>
      <div class="content">{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderRejectReason: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.order-reject-reason{
  margin: 0px 0px 0px 10px;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  color: #FF4812;
  opacity: 1;
  .order-reject-reason-title{
    font-family: Satoshi-bold !important;
  }
  .order-reject-reason-list{

    display: flex;
    margin:5px 0px;
    .seq{
      width: 25px;
    }
    .content{
      width: calc(100% - 25px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/order/order-reject-reason.vue